import { Link as ChakraLink, LinkProps } from "@chakra-ui/react";

const detailLinkStyles = {
  color: "#1D74FF",
  fontFamily: "Work Sans",
  fontSize: "0.875rem",
  fontStyle: "normal",
  fontWeight: 500,
  lineHeight: "140%",
  textAlign: "center",
  textDecoration: "underline",
  _hover: { color: "#1D74FF" },
  sx: {
    textDecorationStyle: "dotted",
    textDecorationSkipInk: "auto",
    textDecorationThickness: "auto",
    textUnderlineOffset: "auto",
    textUnderlinePosition: "from-font",
  },
} as const;

export function CampaignDetailLink({ children, ...props }: LinkProps) {
  return (
    <ChakraLink {...detailLinkStyles} {...props}>
      {children}
    </ChakraLink>
  );
}
